export default __webpack_public_path__ + "static/media/reservation.8cb3b742.png";